"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _httpCore = require("@webex/http-core");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @class
 */
var EmbargoInterceptor = /*#__PURE__*/function (_Interceptor) {
  (0, _inherits2.default)(EmbargoInterceptor, _Interceptor);
  var _super = _createSuper(EmbargoInterceptor);
  function EmbargoInterceptor() {
    (0, _classCallCheck2.default)(this, EmbargoInterceptor);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(EmbargoInterceptor, [{
    key: "onResponseError",
    value:
    /**
     * @see Interceptor#onResponseError
     * @param {Object} options
     * @param {Error} reason
     * @returns {Promise}
     */
    function onResponseError(options, reason) {
      if (reason.statusCode === 451) {
        var device = this.webex.internal.device;
        var loggerMessage = ['Received `HTTP 451 Unavailable For Legal Reasons`, ', 'discarding credentials and device registration'].join('');
        if (device) {
          this.webex.internal.device.clear();
        }
        this.webex.credentials.clear();
        this.webex.logger.info(loggerMessage);
      }
      return _promise.default.reject(reason);
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {EmbargoInterceptor}
     */
    function create() {
      /* eslint no-invalid-this: [0] */
      return new EmbargoInterceptor({
        webex: this
      });
    }
  }]);
  return EmbargoInterceptor;
}(_httpCore.Interceptor);
exports.default = EmbargoInterceptor;
//# sourceMappingURL=embargo.js.map
